import { render, staticRenderFns } from "./TheoryPracticeLessonTheory.vue?vue&type=template&id=65976d39&scoped=true&"
import script from "./TheoryPracticeLessonTheory.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeLessonTheory.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeLessonTheory.vue?vue&type=style&index=0&id=65976d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65976d39",
  null
  
)

export default component.exports